<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title color="rgba(0,0,0,0)">
          <span class="font-weight-regular">Container Options</span>
          <v-divider class="ml-2 mr-2" vertical></v-divider>
          <v-btn @click="initialize" icon>
            <v-icon dark>mdi-sync</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" class="mr-2" clearable dense hide-details label="Search Container Options"
            outlined prepend-inner-icon="mdi-magnify" :disabled="this.containerOptions.length === 0"></v-text-field>
          <v-spacer></v-spacer>
          <v-btn icon color="black" @click="allowedJsonFormatDialog = true"
            class="d-flex align-center justify-center mr-2">
            <v-icon> mdi-help </v-icon>
          </v-btn>
          <v-btn v-if="selected.length > 0" outlined color="error" class="mr-2" @click="bulkDeleteDialog = true">
            <v-icon left>mdi-delete</v-icon>
            Delete Selected ({{ selected.length }})
          </v-btn>
          <v-btn outlined color="primary" @click="showCreateContainerOptionsDialog">
            <v-icon left> mdi-plus </v-icon>
            new container options
          </v-btn>
        </v-card-title>
        <v-card-text class="mb-0 pb-0 mx-0 px-0">
          <v-data-table :loading="containerOptionsLoading" :search="search"
            dense :headers="headers" :items="containerOptions" mobile-breakpoint="0" ref="containerOptionsTable"
            sort-desc :items-per-page="30" :footer-props="{ 'items-per-page-options': [10, 30, 50, -1] }"
            show-select v-model="selected" item-key="id">
            <template v-slot:[`item.name`]="{ item }">
              <span v-if="item.name">{{ item.name }} </span>
            </template>
            <template v-slot:[`item.type`]="{ item }">
              <span v-if="item.type">{{ item.type === 'env' ? 'Environment Variables' : 'Engine Arguments' }}
              </span>
            </template>
            <template v-slot:[`item.options`]="{ item }">
              <span class="text-decoration-underline" @click.self="showOptions(item)" v-if="item.options">See Options as
                JSON </span>
            </template>
            <template v-slot:[`item.edit`]="{ item }">
              <v-btn icon @click="showEditContainerOptionsDialog(item)">
                <v-icon color="primary">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`item.delete`]="{ item }">
              <v-btn icon @click="showDeleteDialogFunc(item)">
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <create-container-options v-if="showCreateContainerOptions" v-model="showCreateContainerOptions" containerNewOrEdit="New"
        @input="showCreateContainerOptions = $event" />
      <create-container-options v-if="showEditContainerOptions" v-model="showEditContainerOptions"
        containerNewOrEdit="Edit" :selectedOptions="selectedOptions" @input="showEditContainerOptions = $event" />

      <ContainerOptionsDialog v-model="showOptionsDialog" :selectedOptions="selectedOptions" />
      <ContainerOptionsDeleteDialog v-model="showDeleteDialog" :selectedOptions="selectedOptions"
        @delete="deleteContainerOptions" />
      <v-dialog v-if="bulkDeleteDialog" v-model="bulkDeleteDialog" max-width="40rem">
        <v-card>
          <v-card-title>
            <span class="headline">Delete Selected</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="bulkDeleteDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-alert type="warning" dense>
              {{ selected.length }} container option(s) will be permanently deleted. Are you sure?
            </v-alert>
            <div class="d-flex justify-end mt-4" style="gap:16px">
              <v-btn @click="bulkDeleteDialog = false">Cancel</v-btn>
              <v-btn color="error" :loading="bulkDeleteLoading" @click="bulkDeleteContainerOptions">Delete</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-if="allowedJsonFormatDialog" v-model="allowedJsonFormatDialog" max-width="65rem">
        <v-card>
          <v-card-title>
            <span class="headline">Allowed JSON Format</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="allowedJsonFormatDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-textarea auto-grow outlined label="JSON Format" :value=JSON.stringify(allowedJsonFormat,undefined,1) readonly></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import { apiService } from '../../service/api.service'
import CreateContainerOptions from '../dockers/CreateContainerOptions.vue'
import ContainerOptionsDeleteDialog from './ContainerOptionsDeleteDialog.vue'
import ContainerOptionsDialog from './ContainerOptionsDialog.vue'
export default {
  components: {
    CreateContainerOptions,
    ContainerOptionsDeleteDialog,
    ContainerOptionsDialog
  },
  data: () => ({
    containerOptions: [],
    containerOptionsLoading: false,
    search: '',
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Type', value: 'type' },
      { text: 'Options', value: 'options' },
      { text: 'Edit', value: 'edit', sortable: false },
      { text: 'Delete', value: 'delete', sortable: false }
    ],
    showCreateContainerOptions: false,
    showEditContainerOptions: false,
    showOptionsDialog: false,
    selectedOptions: null,
    showDeleteDialog: false,
    selected: [],
    bulkDeleteDialog: false,
    bulkDeleteLoading: false,
    allowedJsonFormatDialog: false,
    allowedJsonFormat: [{
      type: 'text | multi | none -- CAN NOT BE NULL OR DIFFERENT',
      option: 'Ex: HUGGING_FACE_HUB_TOKEN -- CAN NOT BE NULL',
      isToken: 'true | false -- CAN NOT BE NULL',
      description: 'Description of the option -- NULLABLE',
      allowed_values: ['value1', 'value2', 'NULLABLE']
    }]
  }),
  mounted () {
    this.initialize()
  },
  methods: {
    async initialize () {
      this.containerOptionsLoading = true
      await apiService.get('admin/container-options').then((response) => {
        this.containerOptions = response.data.container_options
      }).finally(() => {
        this.containerOptionsLoading = false
      })
    },
    showCreateContainerOptionsDialog () {
      this.showCreateContainerOptions = true
    },
    showEditContainerOptionsDialog (item) {
      this.showEditContainerOptions = true
      this.selectedOptions = item
    },
    showOptions (options) {
      this.showOptionsDialog = true
      this.selectedOptions = options
    },
    async deleteContainerOptions (item) {
      await apiService.delete(`admin/container-options/${item.id}`).then((response) => {
        this.initialize()
      }).catch((error) => {
        console.log(error)
      })
      this.showDeleteDialog = false
    },
    async showDeleteDialogFunc (item) {
      this.showDeleteDialog = true
      this.selectedOptions = item
    },
    async bulkDeleteContainerOptions () {
      this.bulkDeleteLoading = true
      try {
        await apiService.delete('admin/container-options/bulk', {
          data: { ids: this.selected.map(item => item.id) }
        })
        this.selected = []
      } catch (error) {
        console.log(error)
      } finally {
        this.bulkDeleteLoading = false
        this.bulkDeleteDialog = false
        this.initialize()
      }
    }
  },
  watch: {
    showEditContainerOptions (val) {
      if (!val) {
        this.initialize()
      }
    },
    showCreateContainerOptions (val) {
      if (!val) {
        this.initialize()
      }
    }
  }
}
</script>
